import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import localeEN from '@angular/common/locales/en';
import localeEs from '@angular/common/locales/es';
import localeFr from '@angular/common/locales/fr';
import localeNl from '@angular/common/locales/nl';
import {
  ApplicationConfig,
  DEFAULT_CURRENCY_CODE,
  importProvidersFrom,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';

import { GoogleTagManagerModule } from 'angular-google-tag-manager';

import { CamPwaService, PWA_CONFIG_KEY } from '@camelot/capacitor';
import { provideGoogleMaps } from '@camelot/core';
import { provideNotification } from '@camelot/notification';
import {
  GRAPHQL_SERVER_CONFIG,
  SERVER_CONFIG_KEY,
  STRAPI_SERVER_CONFIG,
  TENANT_CONFIG_TOKEN,
  provideServer,
} from '@camelot/server';
import { provideTranslation } from '@camelot/translation';
import { provideAuth0, provideUser } from '@camelot/user';
import { APPLICATION_CONFIG, LOCAL } from '@camelot/utils';

import { environment } from '../environments/environment';
import { routes } from './app.routes';

registerLocaleData(localeFr, 'fr');
registerLocaleData(localeEN, 'en');
registerLocaleData(localeNl, 'nl');
registerLocaleData(localeEs, 'es');

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    provideAnimations(),
    provideRouter(routes),
    provideTranslation({
      default: environment.TRANSLATION.DEFAULT,
      supportedLanguages: environment.TRANSLATION.SUPPORTEDLANGUAGES,
    }),
    provideServer({ graphQlConfig: { config: environment.GRAPHQL_SERVER_CONFIG } }),
    provideAuth0({ config: environment.AUTH0 }),
    provideNotification(),
    provideUser(),
    importProvidersFrom(
      GoogleTagManagerModule.forRoot({
        id: environment.GTM,
      })
    ),
    provideGoogleMaps(),
    {
      provide: STRAPI_SERVER_CONFIG,
      useValue: { config: environment.STRAPI_SERVER_CONFIG },
    },
    {
      provide: TENANT_CONFIG_TOKEN,
      useValue: { tenantId: environment.TENANT_ID },
    },
    {
      provide: PWA_CONFIG_KEY,
      useValue: { active: environment.PWAACTIVE },
    },
    {
      provide: LOCAL,
      useValue: { isLocal: environment.LOCAL },
    },
    {
      provide: APPLICATION_CONFIG,
      useValue: { isCustomerApplication: false },
    },
    {
      provide: SERVER_CONFIG_KEY,
      useValue: { pendindRequestId: environment.PENDINGREQUESTAPI, serverUrl: environment.SERVER_URL },
    },
    {
      provide: GRAPHQL_SERVER_CONFIG,
      useValue: { config: environment.GRAPHQL_SERVER_CONFIG },
    },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'EUR' },
    CamPwaService,
    provideServiceWorker('ngsw-worker.js', {
      enabled: environment.PWAACTIVE,
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
};
